export default __webpack_public_path__ + "static/media/claims_header_tab.6fac7e9f.png";